/**
 *
 * @param { array } drive_service_divs - array of all the rows in a drive service div
 * @param { integer } row - row to find parent of
 * @returns { object } object of parent div
 */

const getParentDiv = (drive_service_divs, row) => {
    const parent = drive_service_divs.find((div) => {
        return div.id === parseInt(row.parentElement.id.replace("ds-div-", ""));
    });

    return parent;
};

export default getParentDiv;
